import React from 'react'
import { t } from 'i18n'

const RequiredMark = () => (
  <abbr className='required-mark' title={t('components.form.required_field')}>*</abbr>
)

const RequiredFieldsLegend = () => (
  <p className='required-fields-legend small'>
    <RequiredMark /> {t('components.form.required_fields_legend')}
  </p>
)

export default RequiredMark
export { RequiredFieldsLegend }
